import React from "react";

function SubmitButton() {
  return (
    <div className="add-div">
    <span>Add</span>
    <button className="submit-button" type="submit">
    </button>
    </div>
  );
}

export default SubmitButton;
